module.exports = __webpack_public_path__ + "img/button_bg.ad17e0a7.png";